import "./App.css";

import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Hero from "./components/Hero";

// MAIN PAGES
import Property from "./pages/Property";
import Document from "./pages/Document";
import Startup from "./pages/Startup";
import Challan from "./pages/Challan";
import VehicleReport from "./pages/VehicleReport";
import Blogs from "./pages/Blogs";
import Login from "./pages/Login";

// DROPDOWN PAGES
import PropertyRegistration from "./pages/PropertyRegistration";
import AgreementDrafting from "./pages/AgreementDrafting";
import SaleDeedDrafting from "./pages/SaleDeedDrafting";

import StartupDocuments from "./pages/StartupDocuments";
import LegalAgreements from "./pages/LegalAgreements";

import Trademark from "./pages/Trademark";
import GSTRegistration from "./pages/GSTRegistration";

function App() {
  return (
    <>
      <Navbar />

      <Routes>

        {/* HOME PAGE */}
        <Route path="/" element={<Hero />} />

        {/* MAIN PAGES */}
        <Route path="/property" element={<Property />} />
        <Route path="/document" element={<Document />} />
        <Route path="/startup" element={<Startup />} />
        <Route path="/challan" element={<Challan />} />
        <Route path="/vehicle-report" element={<VehicleReport />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/login" element={<Login />} />

        {/* PROPERTY DROPDOWN */}
        <Route
          path="/property-registration"
          element={<PropertyRegistration />}
        />

        <Route
          path="/agreement-drafting"
          element={<AgreementDrafting />}
        />

        <Route
          path="/sale-deed-drafting"
          element={<SaleDeedDrafting />}
        />

        {/* DOCUMENT DROPDOWN */}
        <Route
          path="/startup-documents"
          element={<StartupDocuments />}
        />

        <Route
          path="/legal-agreements"
          element={<LegalAgreements />}
        />

        {/* STARTUP DROPDOWN */}
        <Route
          path="/trademark"
          element={<Trademark />}
        />

        <Route
          path="/gst-registration"
          element={<GSTRegistration />}
        />

      </Routes>

      <Footer />
    </>
  );
}

export default App;